import { render, staticRenderFns } from "./PhoneValidate.vue?vue&type=template&id=025c78da&scoped=true"
import script from "./PhoneValidate.vue?vue&type=script&lang=js"
export * from "./PhoneValidate.vue?vue&type=script&lang=js"
import style0 from "./PhoneValidate.vue?vue&type=style&index=0&id=025c78da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025c78da",
  null
  
)

export default component.exports